<input
  type="text"

  [value]="displayValue"
  (input)="onInput($event.target.value)"
  (focus)="onFocus()"
  (blur)="onBlur()"
  [readonly]="readonly"
  [attr.placeholder]="placeholder"
  [class.has-error]="hasError"
/>